var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "样式选择",
        width: "606px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "SignStyle",
        },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [
              _c(
                "div",
                { staticClass: "signStyleView" },
                _vm._l(_vm.list, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.value,
                      staticClass: "signStyleViewItem",
                      class: { checkRadio: item.value === _vm.radio },
                      on: {
                        click: function ($event) {
                          _vm.radio = item.value
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "CouponStyleImg",
                        attrs: { src: item.icon },
                      }),
                      _c(
                        "el-radio",
                        {
                          staticClass: "CouponStyleRadio",
                          attrs: { label: item.value },
                        },
                        [_vm._v(_vm._s(item.text))]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
              _c("div", { staticClass: "line" }),
              _c(
                "div",
                {
                  staticClass: "signStyleCustom",
                  class: { checkRadio: _vm.radio === 4 },
                  on: {
                    click: function ($event) {
                      _vm.radio = 4
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "signStyleCustomView" },
                    [
                      !_vm.imgUrl
                        ? _c("div", { staticClass: "signStyleCustomImg" }, [
                            _c("img", {
                              staticClass: "signStyleCustomImgUrl",
                              attrs: {
                                src: require("@/assets/image/live/noPhoto.png"),
                              },
                            }),
                            _c("div", { staticClass: "des" }, [
                              _vm._v("未上传图片"),
                            ]),
                          ])
                        : _c("div", { staticClass: "signStyleCustomBoxImg" }, [
                            _c("img", {
                              staticClass: "signStyleCustomBoxImgSettingimg",
                              attrs: { src: _vm.imgUrl },
                            }),
                            _c("img", {
                              staticClass: "signStyleCustomBoxImgBg",
                              attrs: {
                                src: require("@/assets/image/live/signStyle4.png"),
                              },
                            }),
                          ]),
                      _c(
                        "el-radio",
                        {
                          staticClass: "CouponStyleRadio",
                          attrs: { label: 4 },
                        },
                        [_vm._v("自定义样式")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "uploadView" },
                [
                  [
                    _c("upload", {
                      key: "MUploadVideo",
                      ref: "MUploadVideo",
                      attrs: {
                        type: "btn",
                        width: 160,
                        height: 120,
                        accept: "image/jpeg,image/png,image/jpg",
                        "before-upload": _vm.beforeUpload,
                        "max-length": 1,
                        "upload-text": "上传背景",
                        "oss-teacher-folder": "hok_liveRoom",
                        disabled: _vm.radio !== 4,
                        "custom-style": {
                          height: "88px",
                          "margin-left": "18px",
                          display: "flex",
                          "align-items": "self-end",
                        },
                        "get-oss-c-onfig-api": _vm.getLiveOssCConfig,
                      },
                      on: { onClick: _vm.onImgClick, change: _vm.fileChange },
                    }),
                  ],
                  _c("div", { staticClass: "msgTips" }, [
                    _vm._v("建议尺寸：532*438，jpg、png格式，大小1M以内"),
                  ]),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }